<div class="wrapper">
  <app-view-field
    [hint]="consumptionHint"
    [hintColor]="consumptionHintColor"
    [label]="'Quantity'"
    [uom]="data?.itemPostings?.uom"
    [value]="quantityTotal | number: '1.0-' + getQuantityRounding()"
    class="mb-[30px]"
  />
  <div class="line-items-section">
    @for (lineItem of lineItems; track lineItem.id) {
      <app-item-posting-line-item
        (addContractorClicked)="openAddContractorDialog()"
        (deleteClicked)="deleteLineItem(lineItem.id)"
        (toggleExpand)="selectLineItem(lineItem.id)"
        [contractorOptions]="contractorOptions"
        [form]="lineItemForms[lineItem.id]"
        [isExpanded]="selectedLineItemId === lineItem.id"
        [lineItem]="lineItem"
        [showAddContractorButton]="showAddContractorButton"
        [uom]="data?.itemPostings?.uom"
        [quantityRounding]="getQuantityRounding()"
        [materialSets]="bidItem?.bid_item_material_set || []"
        [bidItemName]="data?.itemPostings?.item || ''"
        [areaCalculationGroups]="areaCalculationGroups"
        [projectLookups]="projectLookups"
        [projectId]="projectId"
        [dailyReportId]="dailyReportId"
        [bidItemId]="data?.itemPostings?.id"
        [editable]="editable"
      />
    }
  </div>
</div>
